import React, { useEffect } from "react";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";
import { useAnnotationsHandler } from "pages/MaterialSpecs/hooks/useAnnotationsHandler";
import { PreviewSelector } from "pages/MaterialSpecs/components/PreviewSelector";
import { Box, CircularProgress } from "@material-ui/core";
import { Dropzone, DropzoneBox, PermissionWrapper, LoadingOverlay } from "components";
import { useDispatch, useSelector } from "react-redux";
import { getMaterialDetailsById } from "store/features/materialSpecs/specs";
import { useUploadAsset } from "hooks/api";
import { useMaterialSpecAssets } from "hooks/api/useMaterialSpecAssets";
import { useQueryCache } from "react-query";
import { useTranslation } from "react-i18next";
import { API } from "api";
import { fetchAnnotations } from "store/features/annotations/annotations.actions";
import { getMaterialType } from "utils";

export const Visual = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const queryClient = useQueryCache();
    const { reset } = useAnnotationsHandler();
    const {
        selectedMaterialSpecId,
        selectedMaterialId,
        setAsset,
        assetId,
        isVisualVisible,
        isPrinted,
    } = useMaterialSpecs();
    const materialDetails = useSelector(getMaterialDetailsById(selectedMaterialSpecId, selectedMaterialId));
    const { data: assets, isFetching } = useMaterialSpecAssets({
        isPrinted,
        materialId: isPrinted ? undefined : selectedMaterialId,
        materialSpecId: selectedMaterialSpecId,
    });
    const [handleUploadAsset, { isLoading: isUploading }] = useUploadAsset("VISUAL", async (uploadedAsset) => {
        if (assets) {
            console.log({ assets, uploadedAsset });
            queryClient.setQueryData(
                ["assets", isPrinted ? selectedMaterialSpecId : selectedMaterialId],
                [...uploadedAsset, ...assets]
            );
        }
    });
    const visualAsset = assets?.find((asset) => asset.type === "VISUAL");

    useEffect(() => {
        if (selectedMaterialSpecId && selectedMaterialId && assetId) {
            reset();
            dispatch(
                fetchAnnotations.request({
                    matSpecId: selectedMaterialSpecId,
                    adMaterialId: selectedMaterialId,
                    assetId,
                })
            );
        }
        // eslint-disable-next-line
    }, [isVisualVisible, assetId]);

    useEffect(() => {
        if (visualAsset) {
            setAsset(visualAsset.id);
        }
    }, [visualAsset, setAsset]);

    if (!visualAsset) {
        return (
            <LoadingOverlay active={isFetching}>
                <Box display="flex" flex={1} height="92%" alignItems="center" justifyContent="center">
                    <PermissionWrapper name="UPLOAD_ASSET" permissions={materialDetails?.permissions}>
                        {({ disabled }) => (
                            <DropzoneBox sizeY={550} display="flex" alignItems="center" justifyContent="center">
                                {isUploading ? (
                                    <CircularProgress color="primary" size={40} />
                                ) : (
                                    <Dropzone
                                        disabled={disabled}
                                        label={t("campaign.label.dragAndDropArea")}
                                        onDrop={(files) => {
                                            if (selectedMaterialSpecId && selectedMaterialId) {
                                                handleUploadAsset({
                                                    files,
                                                    materialSpecId: selectedMaterialSpecId,
                                                    materialId: !isPrinted ? selectedMaterialId : undefined,
                                                });
                                            }
                                        }}
                                    />
                                )}
                            </DropzoneBox>
                        )}
                    </PermissionWrapper>
                </Box>
            </LoadingOverlay>
        );
    }

    const materialType = getMaterialType(visualAsset.originalFile.format);
    const width = visualAsset.originalFile.width ? parseInt(visualAsset.originalFile.width?.split(" ")[0]) : 0;
    const height = visualAsset.originalFile.height ? parseInt(visualAsset.originalFile.height?.split(" ")[0]) : 0;

    return (
        <PreviewSelector
            preview={`${API.serverUrl}${
                materialType === "PDF" || materialType === "EPS"
                    ? visualAsset.bigPreview?.url
                    : visualAsset.originalFile.url
            }`}
            type={materialType}
            width={width}
            height={height}
        />
    );
};
